import { Controller } from "@hotwired/stimulus"

/**
 * Stimulus controller for Bootstrap accordion state persistence
 * Saves/restores accordion open/closed state using localStorage
 *
 * Usage:
 * <div data-controller="accordion"
 *      data-accordion-target="accordion"
 *      data-accordion-storage-key-value="my-accordion"
 *      data-accordion-default-open-value="false">
 *   <button data-action="click->accordion#toggle">Toggle</button>
 *   <div class="collapse">Content</div>
 * </div>
 */
export default class extends Controller {
  static targets = ["accordion"]
  static values = { 
    storageKey: String,
    defaultOpen: { type: Boolean, default: true }
  }

  connect() {
    this.restoreState()
  }

  toggle(event) {
    // Determine if accordion is becoming open or closed
    const isBecomingOpen = event.target.classList.contains('collapsing') 
      ? !event.target.classList.contains('show')
      : event.target.classList.contains('show')
    
    this.saveState(isBecomingOpen)
  }

  restoreState() {
    const key = this.storageKeyValue || this.generateStorageKey()
    const savedState = localStorage.getItem(key)
    
    let shouldBeOpen = this.defaultOpenValue
    if (savedState !== null) {
      shouldBeOpen = savedState === 'true'
    }

    // Remove Bootstrap's 'hide' class and manage state directly
    this.accordionTarget.classList.remove('hide')
    
    if (shouldBeOpen) {
      this.accordionTarget.classList.add('show')
    } else {
      this.accordionTarget.classList.remove('show')
    }
  }

  saveState(isOpen) {
    const key = this.storageKeyValue || this.generateStorageKey()
    localStorage.setItem(key, isOpen.toString())
    console.log(`Saved accordion state: ${isOpen} for key: ${key}`)
  }

  generateStorageKey() {
    return `accordion_state_${this.accordionTarget.id || 'default'}`
  }
}
